import styled, { css } from 'styled-components'
import { flex, flexAlign } from '../ReceivementFreshTag.style.mixins'

const darkGray = (props) => props.theme.colors.darkGray

export const Container = styled.div<{ hasBorder?: boolean }>`
    ${flex('row')}
    justify-content: space-between;
    padding: 0px 12px;

    ${({ hasBorder = false }) =>
    hasBorder
            && css`
                border-bottom: 1px solid ${darkGray};
            `}
`

export const TextLabel = styled.div<{ justifyAt: string }>`
    ${flex('row')}
    ${({ justifyAt }) =>
    css`
        ${flexAlign(justifyAt, 'center')}
    `}
`

export const AdditionalInfoLabelDivider = styled.div`
    display: flex; 
    border-left: 1px solid ${darkGray};
    height: 100%; 
    align-items: center; 
    padding-left: 12px;
`
